import styled from "styled-components";

export const Container = styled.div`
    margin: 0 0.5rem 0.5rem 0.5rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;

    @media (max-width: 930px){
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: 1fr;
    }

    
    .clickable{
        @media (min-width: 960px){
            cursor: pointer;
        }
    }
`

export const Card = styled.div`
    padding: 1rem 0;
    background: var(--colorBackgroundCardsDashboard);
    border-radius: 0.25rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    min-height: 17rem;

    svg{
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        font-size: 1.2rem;
    }
`

export const FilterButton = styled.div`
    position: absolute;
    top: 5px;
    right: 45px;
    z-index: 99;

    @media(max-width: 930px){
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        font-size: 1.2rem;
    }
`;

export const CloseButton = styled.div`
    position: absolute;
    top: 5px;
    right: 10px;
    z-index: 99;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 2rem;
    width: 2rem;
    color: rgb(135, 134, 139);
    font-size: 1rem;
    border-radius: 5px;
    transition: all 0.3s ease 0s;

    @media(max-width: 930px){
        left: 10px;
    }

    &:hover{
        background: rgb(200, 200, 200);
        color: rgb(255, 255, 255);
        cursor: pointer;
    }
`

export const Title = styled.p`
    font-size: 1.2rem;
    color: var(--colorFontsCardsDashboard);
    font-weight: 700;
    position: absolute;
    top: 10px;
    bottom: 0;
`